import { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useUploadResultPdfListApi } from 'api/sample'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import './preview.scss'
import { setPageSize } from 'utils/util'
import { FaArrowUp } from 'react-icons/fa'
import { useFetchNaviSampleApi, useFetchNaviSamplesApi } from 'api/navi_sample'
import { NaviPdfResult } from '@craif/product.pdf-result'
import { NaviSample } from '@craif/product.entities.navi_sample'
import { NaviSampleSearchForm } from 'entities/navi_sample'

type Props = {
    history: H.History
}

const NaviResultDetailPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<NaviSampleSearchForm>()
    const searchForm = useForm<NaviSampleSearchForm>({
        ...params,
        perPage: 1000,
    })
    const samplesApi = useFetchNaviSamplesApi(searchForm)
    const sampleApi = useFetchNaviSampleApi()
    const [selectedSample, setSelectedSample] = useState<Partial<NaviSample>>({})
    const uploadApi = useUploadResultPdfListApi()

    useEffect(() => {
        document.title = selectedSample.code!
        if (selectedSample && selectedSample.id) {
            sampleApi.execute(selectedSample.id!)
        }
    }, [selectedSample])

    useEffectSkipFirst(() => {
        globalState.setLoading(uploadApi.loading)
    }, [uploadApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(samplesApi.loading)
        if (samplesApi.isSuccess()) {
            if (samplesApi.response.results.length === 1) {
                setSelectedSample(samplesApi.response.results[0])
            }
        }
    }, [samplesApi.loading])

    useEffect(() => {
        samplesApi.execute()
        setPageSize('portrait')
    }, [])

    return (
        <div id="top">
            <div className="no-print" style={{ position: 'sticky', top: -20, left: -20, backgroundColor: 'white', padding: 8, zIndex: 1000 }}>
                {selectedSample.id && (
                    <Flex style={{ marginLeft: 20 }} alignItems="flex-end">
                        <div style={{ padding: 15 }}>
                            <Button variant="secondary" size="sm" onClick={() => props.history.push('/navi/results')}>
                                戻る
                            </Button>
                        </div>
                        <div style={{ padding: 15 }}>
                            <Button
                                style={{ width: 200 }}
                                onClick={() => {
                                    window.print()
                                }}
                            >
                                印刷プレビュー
                            </Button>
                        </div>
                    </Flex>
                )}
                <Flex style={{ margin: 20, gap: 10 }} flexWrap="wrap">
                    {samplesApi.response.results.map((sample) => {
                        return (
                            <div
                                id={`sample-${sample.id}`}
                                style={
                                    sample.id === selectedSample.id
                                        ? { fontSize: 18, color: 'black', textDecoration: 'none' }
                                        : { fontSize: 14, color: 'blue', textDecoration: 'underline', cursor: 'pointer' }
                                }
                                key={'selectable-sample-' + sample.id}
                                onClick={() => {
                                    setSelectedSample(sample)
                                }}
                            >
                                {sample.code}
                            </div>
                        )
                    })}
                </Flex>
                <Flex style={{ margin: 20, gap: 10 }}>
                    {sampleApi.response.id &&
                        sampleApi.response.naviIndicationResults?.map((r) => {
                            return (
                                <a key={'link-' + r.naviIndication?.name} href={`#${r.naviIndication?.name}`}>
                                    {r.naviIndication?.name}
                                </a>
                            )
                        })}
                </Flex>
            </div>
            <a
                href="#top"
                className="no-print"
                style={{
                    zIndex: 1000,
                    position: 'fixed',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    top: 30,
                    left: 245,
                    width: 50,
                    height: 50,
                    borderRadius: 50,
                    backgroundColor: '#888',
                }}
            >
                <FaArrowUp color="white"></FaArrowUp>
            </a>
            <div style={{ fontFamily: 'Noto Sans JP' }}>
                {sampleApi.response.id && <NaviPdfResult user={sampleApi.response.patient as any} naviSample={sampleApi.response as any} />}
            </div>
        </div>
    )
}

export default withRouter(NaviResultDetailPage)
